export interface LinhaSelecionada {
  minutos: number;
  valorHora?: number | null;
  ajusteEmHoras?: number | null;
}

export interface TotaisSelecionados {
  quantidade: number;
  minutos: number;
  decimalNaTela: string;
  decimalExato: string;
  divergem: boolean;
  valor: number;
  valorFormatado: string;
  linhasSemValor: number;
  /** Minutos que serão cobrados: a duração mais o ajuste de cada linha. */
  minutosCobranca: number;
  decimalCobranca: string;
}

export const formatarDecimalDeHoras = (valor: number): string =>
  valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    minimumIntegerDigits: 1,
  });

export const formatarReais = (valor: number): string =>
  valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

const arredondarCentavos = (valor: number): number =>
  Math.round((valor + Number.EPSILON) * 100) / 100;

export const totalizarSelecao = (
  linhas: LinhaSelecionada[],
): TotaisSelecionados => {
  const minutos = linhas.reduce((acc, linha) => acc + linha.minutos, 0);

  const centesimos = linhas.reduce(
    (acc, linha) => acc + Math.round((linha.minutos / 60) * 100),
    0,
  );

  const decimalNaTela = formatarDecimalDeHoras(centesimos / 100);
  const decimalExato = formatarDecimalDeHoras(minutos / 60);

  const linhasComValor = linhas.filter((linha) => Number(linha.valorHora) > 0);

  const valor = arredondarCentavos(
    linhasComValor.reduce((acc, linha) => {
      const horas = linha.minutos / 60 + Number(linha.ajusteEmHoras ?? 0);
      return acc + arredondarCentavos(horas * Number(linha.valorHora));
    }, 0),
  );

  const horasCobranca = linhas.reduce(
    (acc, linha) =>
      acc + linha.minutos / 60 + Number(linha.ajusteEmHoras ?? 0),
    0,
  );

  return {
    quantidade: linhas.length,
    minutos,
    decimalNaTela,
    decimalExato,
    divergem: decimalNaTela !== decimalExato,
    valor,
    valorFormatado: formatarReais(valor),
    linhasSemValor: linhas.length - linhasComValor.length,
    minutosCobranca: Math.round(horasCobranca * 60),
    decimalCobranca: formatarDecimalDeHoras(horasCobranca),
  };
};
